function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectTypeCircleSaltmarshRestoration({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.671371,
    y: 0.671371,
    width: 30.8831,
    height: 30.8831,
    rx: 15.4415,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.671371,
    y: 0.671371,
    width: 30.8831,
    height: 30.8831,
    rx: 15.4415,
    stroke: "#69C1DD",
    style: {
      stroke: "#69C1DD",
      stroke: "color(display-p3 0.4118 0.7569 0.8667)",
      strokeOpacity: 1
    },
    strokeWidth: 1.34274
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2004_4248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1443 14.2582C22.8638 14.1449 22.5423 14.247 22.3788 14.5016L17.4402 22.1889L18.2284 17.2933C18.9932 17.1518 19.6231 16.5426 19.7517 15.7318L20.5391 10.7628C20.6181 10.2646 20.4983 9.7655 20.2018 9.35743C20.0334 9.12564 19.8194 8.93913 19.5746 8.8067L19.6898 8.07995C19.7442 7.73663 19.51 7.41421 19.1667 7.35978C18.8231 7.30528 18.5009 7.53958 18.4465 7.88295L18.3312 8.61083C17.567 8.75283 16.9377 9.36146 16.8093 10.1718L16.0218 15.1408C15.9429 15.639 16.0627 16.1381 16.3592 16.5462C16.5273 16.7776 16.7409 16.9639 16.9851 17.0963L15.86 24.0849L15.0242 22.6108L14.0418 15.1812C14.2891 15.0574 14.5079 14.8792 14.6832 14.6548C14.9937 14.2573 15.1309 13.7627 15.0694 13.2621L14.4559 8.26869C14.3559 7.45428 13.7484 6.82429 12.9895 6.65569L12.8996 5.92407C12.8572 5.57903 12.5427 5.33368 12.1982 5.37611C11.8531 5.41849 11.6078 5.73252 11.6502 6.07756L11.7399 6.80788C11.4907 6.9317 11.2703 7.11062 11.0939 7.33641C10.7833 7.73394 10.6462 8.22853 10.7077 8.72916L11.3211 13.7225C11.4214 14.5387 12.0314 15.1699 12.7926 15.3367L13.3682 19.6902L8.33788 10.8183C8.18355 10.5461 7.85274 10.4285 7.56124 10.5425C7.26982 10.6564 7.1063 10.9671 7.17747 11.2718L10.7021 26.3688C10.7699 26.6592 11.0286 26.8553 11.3145 26.8552C11.3619 26.8552 11.41 26.8498 11.4581 26.8386C11.7966 26.7595 12.007 26.4211 11.928 26.0826L9.39562 15.2359L15.4441 25.9035C15.4447 25.9046 15.4453 25.9055 15.4458 25.9065L15.8028 26.5361C15.9743 26.8385 16.3584 26.9445 16.6608 26.7732C16.9632 26.6017 17.0693 26.2176 16.8978 25.9152L16.7313 25.6215L21.6376 17.9843L20.0131 26.1022C19.9449 26.443 20.1659 26.7746 20.5068 26.8428C20.5485 26.8512 20.59 26.8552 20.6309 26.8552C20.9247 26.8552 21.1876 26.6483 21.2474 26.3492L23.5255 14.9653C23.5849 14.6686 23.4248 14.3717 23.1443 14.2582ZM11.9571 8.57563C11.9366 8.40871 11.9823 8.24389 12.0858 8.11138C12.1893 7.97891 12.3383 7.89465 12.5052 7.87422C12.5311 7.87103 12.5568 7.86948 12.5823 7.86948C12.8954 7.86948 13.1674 8.10366 13.2065 8.42218L13.82 13.4156C13.8405 13.5825 13.7947 13.7473 13.6912 13.8798C13.5877 14.0123 13.4388 14.0965 13.272 14.117H13.2719C12.9274 14.1592 12.6129 13.9134 12.5706 13.569L11.9571 8.57563ZM17.2651 15.3378L18.0526 10.3688C18.1068 10.0261 18.4299 9.7916 18.7724 9.8456C18.7725 9.8456 18.7726 9.84564 18.7727 9.84564C18.7728 9.84564 18.7728 9.84564 18.7729 9.84568C18.9388 9.87208 19.0846 9.96137 19.1833 10.0973C19.2822 10.2333 19.3221 10.3997 19.2958 10.5658L18.5083 15.5348C18.454 15.8774 18.1311 16.112 17.7882 16.0579C17.6222 16.0316 17.4763 15.9422 17.3775 15.8062C17.2787 15.6702 17.2388 15.5038 17.2651 15.3378Z",
    fill: "#69C1DD",
    style: {
      fill: "#69C1DD",
      fill: "color(display-p3 0.4118 0.7569 0.8667)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2004_4248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.1871,
    height: 21.4839,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(7.16113 5.37085)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectTypeCircleSaltmarshRestoration);
export default __webpack_public_path__ + "static/media/project-type-circle-saltmarsh-restoration.686f1f3d405c919c280a09ce5b95d3d1.svg";
export { ForwardRef as ReactComponent };